export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) return
  const event = useRequestEvent()
  event.res.setHeader('Cache-Control', 'no-store')
  event.res.setHeader('Pragma', 'no-cache')
  event.res.setHeader('X-Frame-Options', 'DENY')
})
